import * as React from 'react';

import Illustration, { IllustrationColorProps } from './Illustration';

export const IllustrationEverything: React.FunctionComponent<IllustrationColorProps> = ({
  color,
}) => {
  return (
    <Illustration
      color={color}
      strokes={
        <>
          <path d="M10.1691 24.5299L6.43252 22.219C6.25244 22.1506 6.29812 21.8841 6.49138 21.8797L14.4663 21.7163" />
          <path d="M22.8042 21.494L29.9416 21.4039C30.2332 21.3978 30.5222 21.4635 30.7823 21.5968L36.411 26.1769" />
          <path d="M49.1654 37.6358V44.4986C49.1654 45.3684 48.6033 46.1384 47.7749 46.4035L40.9305 48.5937" />
          <path d="M12.8832 26.2868V46.4734C12.8832 47.1196 13.3848 47.6553 14.0314 47.6982L34.2853 49.0459C35.4396 49.1227 36.4181 48.2071 36.4181 47.0503V26.2868" />
          <path d="M36.5145 26.0332L49.9001 20.8558L59.6159 21.5642C59.8127 21.5782 59.8399 21.8561 59.6493 21.9078L49.0443 26.9128" />
          <path d="M17.2181 39.6389V43.6701L27.6521 44.15L27.6666 37.6142L21.441 37.4358" />
        </>
      }
      fills={
        <>
          <path d="M28.0607 26.6971C28.3369 26.6941 28.5582 26.4678 28.5552 26.1917C28.5522 25.9155 28.3259 25.6942 28.0497 25.6972L28.0607 26.6971ZM13.1005 26.8615L28.0607 26.6971L28.0497 25.6972L13.0896 25.8615L13.1005 26.8615Z" />
          <path d="M44.4518 27.1623C44.1794 27.2074 43.9951 27.4649 44.0402 27.7373C44.0854 28.0097 44.3428 28.194 44.6152 28.1489L44.4518 27.1623ZM49.0191 26.4059L44.4518 27.1623L44.6152 28.1489L49.1825 27.3925L49.0191 26.4059Z" />
        </>
      }
      shadows={
        <>
          <path d="M50.0529 20.651L38.2882 25.5413L49.0803 46.2552L49.2698 26.7848L59.419 21.8556L50.0529 20.651Z" />
          <path d="M31.871 34.005H12.6572V26.0137L6.55907 22.1585L30.3972 21.6078L36.4953 26.2552V28.8641H34.0056L31.871 34.005Z" />
          <path d="M49.1799 48.4724V45.3653L36.4883 49.5512L15.0109 47.7555H7.14261C5.83711 47.7555 4.77879 48.8138 4.77879 50.1193L36.0671 53.0102L49.1799 48.4724Z" />
        </>
      }
      dots={
        <>
          <circle cx="34.6359" cy="18.9518" r="0.9" />
          <circle cx="39.1132" cy="18.9518" r="0.9" />
          <circle cx="37.5536" cy="15.8466" r="0.9" />
          <circle cx="32.6907" cy="16.0985" r="0.9" />
          <circle cx="28.9262" cy="17.0194" r="0.9" />
          <circle cx="24.8344" cy="18.5025" r="0.9" />
          <circle cx="26.6344" cy="13.826" r="0.9" />
          <circle cx="22.4423" cy="15.8466" r="0.9" />
          <circle cx="20.3574" cy="19.4025" r="0.9" />
          <circle cx="34.5233" cy="12.5715" r="0.9" />
          <circle cx="30.5527" cy="11.2223" r="0.9" />
          <circle cx="44.2387" cy="17.9427" r="0.9" />
          <circle cx="36.5511" cy="22.2231" r="0.9" />
          <circle cx="41.9578" cy="15.087" r="0.9" />
        </>
      }
    />
  );
};

export default IllustrationEverything;
